/**
 * 💰 経理 Hub (v3.3 IA 刷新で新設)
 *
 * 統合対象:
 *   - sales.commission-ledger (報酬台帳)
 *   - sales.sa-invoices (SA 請求書 管理者用)
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { CommissionLedgerPage } from '@/pages/commission-ledger/CommissionLedgerPage';
import { CommissionInvoicesPage } from '@/pages/commission-invoices/CommissionInvoicesPage';
import { TransferRequestsPage } from '@/pages/transfer-requests/TransferRequestsPage';

const TABS: TabSpec[] = [
  { tabKey: 'ledger',    label: '報酬台帳', featureId: 'sales.commission-ledger', render: () => <CommissionLedgerPage /> },
  { tabKey: 'invoices',  label: 'SA請求書', featureId: 'sales.sa-invoices',       render: () => <CommissionInvoicesPage /> },
  { tabKey: 'transfers', label: '送金依頼', featureId: 'sales.transfer-requests', render: () => <TransferRequestsPage /> },
];

export function FinanceHubPage() {
  return <HubTabs tabs={TABS} defaultTab="ledger" />;
}
